






































import {
  apiOrderWriteOffChooseStore,
  apiOrderWriteOffUserStoreList,
} from '@/api'
import { BookComponents } from '../components'
import { computed, ref, watch } from '@vue/composition-api'
import { defineClassComponent, useApi, useQuery } from '@/hooks'
import { navigateBack } from '@/router'
import { submit, Track } from '@/utils'

export default defineClassComponent(
  {
    components: BookComponents,
  },
  () =>
    class {
      constructor() {
        Track.useMark(() => ({
          page: '我的店铺',
        }))

        watch(
          () => this.storeData.value,
          () => {
            if (this.storeData.value?.length && !this.selectedStore.value) {
              this.selectedStore.value = this.storeData.value[0].merchantId!
            }
          },
          {
            immediate: true,
          },
        )
      }

      query = useQuery<{
        martId: string
      }>()

      apiData = useApi(() => apiOrderWriteOffUserStoreList())

      storeData = computed(() => this.apiData.data)

      selectedStore = ref(this.query.martId)

      handleChangeStoreClick = () => {
        submit(async $ => {
          $.start()
          await apiOrderWriteOffChooseStore({
            merchantId: this.selectedStore.value,
          })
          navigateBack()
        })
      }
    },
)
